(() => {
  const createMessage = (role, text, typing = false) => {
    const row = document.createElement('div');
    row.className = `manual-chat__message manual-chat__message--${role}`;
    const bubble = document.createElement('div');
    bubble.className = 'manual-chat__bubble';
    if (typing) {
      bubble.innerHTML = '<span class="manual-chat__typing" aria-label="Writing a reply"><i></i><i></i><i></i></span>';
    } else {
      bubble.textContent = text;
    }
    row.appendChild(bubble);
    return row;
  };

  const initialise = (root) => {
    if (root.dataset.manualChatReady === 'true') return;
    root.dataset.manualChatReady = 'true';

    const endpoint = root.dataset.endpoint;
    const product = root.dataset.productKey;
    const productName = root.dataset.productName;
    const form = root.querySelector('[data-manual-chat-form]');
    const input = root.querySelector('[data-manual-chat-input]');
    const send = root.querySelector('[data-manual-chat-send]');
    const messages = root.querySelector('[data-manual-chat-messages]');
    const error = root.querySelector('[data-manual-chat-error]');
    const history = [];

    const scrollToLatest = () => messages.scrollTo({ top: messages.scrollHeight, behavior: 'smooth' });
    const showError = (text) => {
      error.textContent = text;
      error.hidden = !text;
    };

    const ask = async (question, focusInput = true) => {
      if (!question || send.disabled) return;
      showError('');
      messages.appendChild(createMessage('user', question));
      history.push({ role: 'user', content: question });
      const typing = createMessage('assistant', '', true);
      messages.appendChild(typing);
      scrollToLatest();
      send.disabled = true;
      input.disabled = true;

      try {
        if (!endpoint) throw new Error('This product assistant has not been connected yet.');
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ product, messages: history.slice(-10) })
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error || 'I could not retrieve an answer just now.');
        const answer = String(payload.answer || '').trim();
        if (!answer) throw new Error('I could not retrieve an answer just now.');
        typing.replaceWith(createMessage('assistant', answer));
        history.push({ role: 'assistant', content: answer });
      } catch (requestError) {
        typing.remove();
        showError(requestError.message || 'Something went wrong. Please try again.');
      } finally {
        send.disabled = false;
        input.disabled = false;
        if (focusInput) input.focus({ preventScroll: true });
        scrollToLatest();
      }
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const question = input.value.trim();
      input.value = '';
      input.style.height = '';
      ask(question);
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        form.requestSubmit();
      }
    });
    input.addEventListener('input', () => {
      input.style.height = 'auto';
      input.style.height = `${Math.min(input.scrollHeight, 120)}px`;
    });
    root.querySelectorAll('[data-manual-chat-prompt]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelector('.manual-chat__window')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        ask(button.textContent.trim(), false);
      });
    });

    if (!endpoint && window.Shopify && Shopify.designMode) {
      showError(`Add the Vercel API endpoint in this section's settings to enable ${productName} questions.`);
    }
  };

  const initialiseAll = (scope = document) => scope.querySelectorAll('[data-manual-chat]').forEach(initialise);
  document.addEventListener('DOMContentLoaded', () => initialiseAll());
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
